import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { NumberText } from "share-components/atomics/number-text";
import { TextNoTranform } from "share-components/atomics/text-no-tranform";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";

export const ManufactoringInformationTable = observer(() => {
  const {
    productManagement: { productDetail },
  } = useStores();
  return (
    <XTablePagination hidePagination>
      <TableHead>
        <TableRow>
          <TableCell rowSpan={2}>Tiêu Chuẩn Xuất Giấy</TableCell>
          <TableCell align="center" colSpan={3}>
            Giấy Nguyên 1<TextNoTranform>{` (mm)`}</TextNoTranform>
          </TableCell>
          <TableCell align="center" colSpan={3}>
            Giấy Nguyên 2<TextNoTranform>{` (mm)`}</TextNoTranform>
          </TableCell>
          <TableCell align="center" colSpan={3}>
            Khổ Giấy In 1 <TextNoTranform>{` (mm)`}</TextNoTranform>
          </TableCell>
          <TableCell align="center" colSpan={3}>
            Khổ Giấy In 2 <TextNoTranform>{` (mm)`}</TextNoTranform>
          </TableCell>
          <TableCell rowSpan={2}>Tiêu chuẩn in</TableCell>
          <TableCell align="center" colSpan={5}>
            In Mặt Trước
          </TableCell>
          <TableCell align="center" colSpan={5}>
            In Mặt Sau
          </TableCell>
          <TableCell rowSpan={2}>Ghi Chú In Ấn</TableCell>
          <TableCell rowSpan={2}>Tiêu Chuẩn Xử Lý Láng</TableCell>
          <TableCell rowSpan={2}>Tiêu Chuẩn Nghiệm Thu</TableCell>
          <TableCell rowSpan={2}>Hiệu Ứng - Xử Lý Khác</TableCell>
          <TableCell colSpan={3}>Ép Nhũ Khiếm Thị</TableCell>
          <TableCell colSpan={3}>Bế Định Hình</TableCell>
          <TableCell colSpan={3}>Cắt T/P</TableCell>
          <TableCell colSpan={3}>Dán T/P</TableCell>
          <TableCell colSpan={3}>Đóng Gói</TableCell>
          <TableCell rowSpan={2}>Tiêu Chuẩn</TableCell>
          <TableCell rowSpan={2}>Chi tiết xử lý</TableCell>
          <TableCell rowSpan={2}>Ghi chú</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Khổ</TableCell>
          <TableCell>Dài</TableCell>
          <TableCell>Số tờ in</TableCell>
          <TableCell>Khổ</TableCell>
          <TableCell>Dài</TableCell>
          <TableCell>Số tờ in</TableCell>
          <TableCell>Khổ</TableCell>
          <TableCell>Dài</TableCell>
          <TableCell>SP</TableCell>
          <TableCell>Khổ</TableCell>
          <TableCell>Dài</TableCell>
          <TableCell>SP</TableCell>
          <TableCell>Màu in</TableCell>
          <TableCell>Mã Màu</TableCell>
          <TableCell>Láng</TableCell>
          <TableCell>Cách X/L</TableCell>
          <TableCell>Xử Lý Khác</TableCell>
          <TableCell>Màu in</TableCell>
          <TableCell>Mã Màu</TableCell>
          <TableCell>Láng</TableCell>
          <TableCell>Cách X/L</TableCell>
          <TableCell>Xử Lý Khác</TableCell>
          <TableCell>Tiêu Chuẩn Xử Lý</TableCell>
          <TableCell>Cách Xử Lý</TableCell>
          <TableCell>Ghi Chú</TableCell>
          <TableCell>Tiêu Chuẩn Định Hình</TableCell>
          <TableCell>Cách Xử Lý</TableCell>
          <TableCell>Ghi Chú</TableCell>
          <TableCell>Tiêu Chuẩn Cắt</TableCell>
          <TableCell>Cách Xử Lý</TableCell>
          <TableCell>Ghi Chú</TableCell>
          <TableCell>Tiêu Chuẩn Dán</TableCell>
          <TableCell>Cách Xử Lý</TableCell>
          <TableCell>Ghi Chú</TableCell>
          <TableCell>Tiêu Chuẩn Đóng Gói</TableCell>
          <TableCell>Cách Xử Lý</TableCell>
          <TableCell>Ghi Chú</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>
            {productDetail?.process?.paperOutputStandard || ""}
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.firstFullPaperSize}
              fixedDecimalScale={true}
              decimalScale={1}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.firstFullPaperLength}
              fixedDecimalScale={true}
              decimalScale={1}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.firstFullPaperPrintQuantity}
              fixedDecimalScale={true}
              decimalScale={1}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.secondFullPaperSize}
              fixedDecimalScale={true}
              decimalScale={1}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.secondFullPaperLength}
              fixedDecimalScale={true}
              decimalScale={1}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.secondFullPaperPrintQuantity}
              fixedDecimalScale={true}
              decimalScale={1}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.printPaperSize}
              fixedDecimalScale={true}
              decimalScale={1}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.printPaperLength}
              fixedDecimalScale={true}
              decimalScale={1}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.printPaperSP}
            ></NumberText>
          </TableCell>

          <TableCell>
            <NumberText
              value={productDetail?.process?.secondPrintPaperSize}
              fixedDecimalScale={true}
              decimalScale={1}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.secondPrintPaperLength}
              fixedDecimalScale={true}
              decimalScale={1}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.secondPrintPaperSP}
            ></NumberText>
          </TableCell>
          <TableCell>{productDetail?.process?.printStandard || ""}</TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.frontPrintColor}
            ></NumberText>
          </TableCell>
          <TableCell>
            {productDetail?.process?.frontPrintColorCode || ""}
          </TableCell>
          <TableCell>{productDetail?.process?.frontPrintMatte || ""}</TableCell>
          <TableCell>
            {productDetail?.process?.frontPrintHandleWay || ""}
          </TableCell>
          <TableCell>
            {productDetail?.process?.frontPrintOtherHandling || ""}
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.process?.backPrintColor}
            ></NumberText>
          </TableCell>
          <TableCell>
            {productDetail?.process?.backPrintColorCode || ""}
          </TableCell>

          <TableCell>{productDetail?.process?.backPrintMatte || ""}</TableCell>
          <TableCell>
            {productDetail?.process?.backPrintHandleWay || ""}
          </TableCell>
          <TableCell>
            {productDetail?.process?.backPrintOtherHandling || ""}
          </TableCell>
          <TableCell>
            {productDetail?.process?.printNote || ""}
          </TableCell>
          <TableCell>
            {productDetail?.process?.coatingStandard || ""}
          </TableCell>
          <TableCell>
            {productDetail?.process?.acceptanceStandard || ""}
          </TableCell>
          <TableCell>{productDetail?.process?.otherHandle || ""}</TableCell>
          <TableCell>{productDetail?.process?.foilProcessingStandard || ""}</TableCell>
          <TableCell>{productDetail?.process?.foil || ""}</TableCell>
          <TableCell>{productDetail?.process?.foilNote || ""}</TableCell>
          <TableCell>{productDetail?.process?.shapeFormingStandard || ""}</TableCell>
          <TableCell>{productDetail?.process?.shape || ""}</TableCell>
          <TableCell>{productDetail?.process?.shapeNote || ""}</TableCell>
          <TableCell>{productDetail?.process?.cutStandard || ""}</TableCell>
          <TableCell>{productDetail?.process?.cut || ""}</TableCell>
          <TableCell>{productDetail?.process?.cutNote || ""}</TableCell>
          <TableCell>{productDetail?.process?.pasteStandard || ""}</TableCell>
          <TableCell>{productDetail?.process?.paste || ""}</TableCell>
          <TableCell>{productDetail?.process?.pasteNote || ""}</TableCell>
          <TableCell>{productDetail?.process?.packageStandard || ""}</TableCell>
          <TableCell>{productDetail?.process?.package || ""}</TableCell>
          <TableCell>{productDetail?.process?.packageNote || ""}</TableCell>
          <TableCell>{productDetail?.process?.standard || ""}</TableCell>
          <TableCell>{productDetail?.process?.handleDetail || ""}</TableCell>
          <TableCell>{productDetail?.process?.note || ""}</TableCell>
        </TableRow>
      </TableBody>
    </XTablePagination>
  );
});
